var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "files"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 15,
    height: 15,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_631",
    "data-name": "Mask Group 631",
    transform: "translate(-39 -143)",
    clipPath: "url(#files)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_74_",
    "data-name": "svgexport-6 (74)",
    transform: "translate(37.928 141.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11485",
    "data-name": "Path 11485",
    d: "M14.464,3.214H8.036a1.607,1.607,0,0,0-1.2-.536H2.679A1.607,1.607,0,0,0,1.071,4.286v8.571a1.607,1.607,0,0,0,1.607,1.607H14.464a1.607,1.607,0,0,0,1.607-1.607V4.821A1.607,1.607,0,0,0,14.464,3.214ZM15,4.821v.1a1.607,1.607,0,0,0-.536-.1H9.236a.536.536,0,0,1-.482-.295l-.118-.241h5.829A.536.536,0,0,1,15,4.821Zm0,8.036a.536.536,0,0,1-.536.536H2.679a.536.536,0,0,1-.536-.536V4.286a.536.536,0,0,1,.536-.536H6.836a.536.536,0,0,1,.482.295L7.795,5a1.607,1.607,0,0,0,1.441.889h5.229A.536.536,0,0,1,15,6.429Z",
    fill: "#6a6f73"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.461280ffa985caf139b38f6f411e5ceb.svg";
export { ForwardRef as ReactComponent };